var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFutbolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.662,
    height: 23.662,
    viewBox: "0 0 23.662 23.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1696",
    "data-name": "Trazado 1696",
    d: "M59.831,48A11.831,11.831,0,1,0,71.662,59.831,11.832,11.832,0,0,0,59.831,48Zm2.341,22.421a15.49,15.49,0,0,1-2.5.253,10.839,10.839,0,0,1-2.19-.256l-.387-.1L55.7,66.6l1.117-2.214h6.021l.032.061,1.1,2.21-1.343,3.656Q62.4,70.37,62.172,70.421ZM56.053,49.665,59.319,51.9v3.307l-4.038,3.417-2.81-1.28-.237-.108-1.27-3.641A10.9,10.9,0,0,1,56.053,49.665ZM68.68,53.578,67.4,57.246l-3.071,1.387-4.046-3.425V51.9l3.276-2.242A10.957,10.957,0,0,1,68.68,53.578ZM49.032,60.822l3.058-2.646,2.818,1.285.032.015,1.122,4.4L54.9,66.063l-3.974-.052A10.778,10.778,0,0,1,49.032,60.822Zm15.732,5.242L63.6,63.872l1.124-4.4,2.844-1.3,3.061,2.649a10.78,10.78,0,0,1-1.893,5.19Z",
    transform: "translate(-48 -48)",
    fill: "#1d1e1f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutbolIcon);
export default __webpack_public_path__ + "static/media/futbol-icon.3e61440cadf7c38bd0f0b7d4151784bb.svg";
export { ForwardRef as ReactComponent };